import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EventManagerService } from 'src/app/core/services/event-manager/event-manager.service';
import { ConfirmationModalComponent } from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import { EventContent } from '../../../../core/services/event-manager/models/event-content';
import { EventType } from '../../../../constants/events-type';
import { RosterService } from '../../../../core/services/http/roster/roster.service';
import { Roster } from '../../../../core/services/http/roster/interfaces/roster';
import { RosterUploadFileType } from 'src/app/core/services/http/roster/enums/roster-upload-file-types';

@Component({
    selector: 'app-roster-preview-modal',
    templateUrl: './roster-preview-modal.component.html',
    standalone: false
})
export class RosterPreviewModalComponent extends ConfirmationModalComponent implements OnInit {
  public roster: Roster | undefined;
  uploadFileTypes = RosterUploadFileType;
  
  constructor(
      protected modalRef: BsModalRef,
      protected eventManager: EventManagerService,
      protected rosterService: RosterService
  ) {
    super(modalRef, eventManager);
  }

  ngOnInit(): void {
    this.loadRoster();
  }

  private loadRoster(): void {
    if (!this.modal?.uuid) {
      return;
    }

    this.eventManager.broadcast(new EventContent(EventType.PreloaderShow, true));

    this.rosterService.getById(this.modal.uuid).subscribe(roster => {
      this.roster = roster;
      this.eventManager.broadcast(new EventContent(EventType.PreloaderShow, false));
    });
  }
}
